import axios from "axios"
import GlobalVariable from "./global"
const baseApiUrl = GlobalVariable.BASE_API_URL
const headerText = GlobalVariable.headerText
const specialCharacterPattern = /^[^#]*$/
const specialCharacterErrorMessage = "Special Character '#' is not allowed"
const DocusignTitle = 'You have received an email attachment from DocuSign. Please review and sign the document.'
const InvoicePaymentModes = [{ value: 1, label: 'WireTransfer' }, { value: 2, label: 'CreditCard' }, { value: 3, label: 'PayLater' }, { value: 4, label: 'GPay' }, { value: 5, label: 'ApplePay' }]
const InvoicePaymentStatus = [{ value: 1, label: 'Pending' }, { value: 2, label: 'Processed' }, { value: 3, label: 'Failed' }]
const WOStatus = [{ value: 1, label: 'Active' }, { value: 2, label: 'Cancelled' }, { value: 3, label: 'Archived' }]
const errorresponse = "Something Went Wrong. Please approach technical team."
const datesList = ["st", "nd", "rd", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th", "th", "st"]
const monthnames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
const fullmonthnames = [
  { key: '01', value: 'Jan' },
  { key: '02', value: 'Feb' },
  { key: '03', value: 'Mar' },
  { key: '04', value: 'Apr' },
  { key: '05', value: 'May' },
  { key: '06', value: 'Jun' },
  { key: '07', value: 'Jul' },
  { key: '08', value: 'Aug' },
  { key: '09', value: 'Sep' },
  { key: '10', value: 'Oct' },
  { key: '11', value: 'Nov' },
  { key: '12', value: 'Dec' }
]
const PaymentInstructions = `<div>
<div class="payment-instructions">PAYMENT INSTRUCTIONS</div>
<div class="wire-transfer-info">
<span class="wire-transfer-title">WIRE TRANSFER:</span>
<span class="wire-transfer-description">Please remit payment to one of the following bank accounts.</span>
</div>
<div class="bank-accounts">
<div class="bank-details">
<div class="bank-column">
<div class="bank-row">
<span class="bank-label">Bank Name:</span>
<span class="bank-info">Bank of America N.A. McLean, VA 22102, USA</span>
</div>
<div class="bank-row">
<span class="bank-label">Swift Code:</span>
<span class="bank-info">BOFAUS3N</span>
</div>
<div class="bank-row">
<span class="bank-label">Routing #:</span>
<span class="bank-info">026009593</span>
</div>
<div class="bank-row">
<span class="bank-label">Account Name:</span>
<span class="bank-info">LISCR,LLC - Maritime</span>
</div>
<div class="bank-row">
<span class="bank-label">Account #:</span>
<span class="bank-info">435059558880</span>
</div>
</div>
<div class="bank-column">
<div class="bank-row">
<span class="bank-label">Bank Name:</span>
<span class="bank-info">JPMorgan Chase, New York, NY 10017, USA</span>
</div>
<div class="bank-row">
<span class="bank-label">Swift Code:</span>
<span class="bank-info">CHASUS33</span>
</div>
<div class="bank-row">
<span class="bank-label">Routing #:</span>
<span class="bank-info">021000021</span>
</div>
<div class="bank-row">
<span class="bank-label">Account Name:</span>
<span class="bank-info">LISCR,LLC - Maritime</span>
</div>
<div class="bank-row">
<span class="bank-label">Account #:</span>
<span class="bank-info">826835669</span>
</div>
</div>
</div>
</div>
<div class="payment-bottom-space"></div>
</div>`

const PaymentInstructionsforCO = `
 <div style="font-family:Times New Roman!important;margin:0 auto;line-height:25px;font-size:16px;color:#000">
  <div style="font-family:Times New Roman!important;margin:0 auto;font-size:16px">
      
        <div style="margin-top:10px;display:flex;font-size:16px!important">
          <div style="font-weight:600;color: #00ADC3;font-size: 16px;width:12%">I.</div>
          <div>
            <div style="font-weight:600;color: #00ADC3;font-size: 16px;">BANK (WIRE) TRANSFER</div>
            <div style="word-spacing:0;font-size:16px;line-height:19px">Bank transfer payments often reach LISCR without a complete description of the purpose of the payment. To ensure credit to the Liberian entity in respect of which you are making payment, please email a copy of your bank's confirmation of transfer to&nbsp; <a href="mailto:corporate@liscr.com" style="color:#00f">corporate@liscr.com</a>, and reference the invoice number(s) to be paid. </div>
            <div style="line-height:18px">
              <span style="font-weight:500;color:red">Bank charges are the sender's responsibility.</span>&nbsp;Please ensure that your instruction to your bank states that all charges are to the account of the payer. LISCR can only credit to the account of the Liberian entity the actual amount received. If bank charges are not provided for in addition to the invoice/outstanding tax and/or fee, the payment may be insufficient and the entity is at risk of a penalty and a delay in restoration to goodstanding.
            </div>
            <div style="font-weight:500;font-size:16px;margin:0">To send your payment by bank transfer, your bank will require the following information:</div>
            <div style="font-weight:600;font-size:14px">Amount must be remitted in US Dollars</div>
            <div style="display:flex;justify-content:space-between;margin:7px 0;line-height:15px;font-size:14px">
              <div style="width:48%;padding-top:0">
                <div style="font-weight:700;color:red;text-align:center">Wire Transfers&nbsp; <u>outside</u>&nbsp;the USA </div>
                <div style="display:flex;margin-top:8px;margin-bottom:5px">
                  <div style="width:40%">Bank Name:</div>
                  <div style="width:60%;color:#00f;line-height:15px">JPMorgan Chase New York, NY 10017 USA</div>
                </div>
                <div style="display:flex;margin-bottom:5px">
                  <div style="width:40%">Swift Code:</div>
                  <div style="width:60%">CHASUS33</div>
                </div>
                <div style="display:flex;margin-bottom:5px">
                       <div style="width:40%">Beneficiary Account Number:</div>
                  <div style="width:60%">527288537</div>
                
                </div>
                <div style="display:flex">
                  <div style="width:40%">Beneficiary Name:</div>
                  <div style="width:60%">LISCR - The LISCR Trust Company</div>
                </div>
              </div>
              <div style="width:48%;padding-top:0">
                <div style="font-weight:700;color:red;text-align:center">Wire Transfers&nbsp; <u>within</u>&nbsp;the USA </div>
                <div style="display:flex;margin-bottom:5px;margin-top:8px">
                  <div style="width:40%">Bank Name:</div>
                  <div style="width:60%;color:#00f;line-height:15px">JPMorgan Chase New York, NY 10017 USA</div>
                </div>
                <div style="display:flex;margin-bottom:5px">
                  <div style="width:40%">ABA Number:</div>
                  <div style="width:60%">021000021</div>
                </div>
                 <div style="display:flex;margin-bottom:5px">
                       <div style="width:40%">Beneficiary Account Number:</div>
                  <div style="width:60%">527288537</div>
                </div>
                <div style="display:flex">
                  <div style="width:40%">Beneficiary Name:</div>
                  <div style="width:60%">LISCR - The LISCR Trust Company</div>
                </div>
              </div>
            </div>
            <div style="text-align:center;margin:0 0;font-weight:600">OR</div>
            <div style="display:flex;justify-content:space-between;margin:0 0;line-height:15px;font-size:14px">
              <div style="width:48%;padding:1px">
                <div style="display:flex;margin-bottom:5px">
                  <div style="width:40%">Bank Name:</div>
                  <div style="width:60%;color:#00f">Bank of America N.A. <br>8300 Greensboro Dr. Suite 360 <br>McLean, VA 22102, USA </div>
                </div>
                <div style="display:flex;margin-bottom:5px">
                  <div style="width:40%">Swift Code:</div>
                  <div style="width:60%">BOFAUS3N</div>
                </div>
                 <div style="display:flex;margin-bottom:5px">
                       <div style="width:40%">Beneficiary Account Number:</div>
                  <div style="width:60%">435059558233</div>
                
                </div>
                <div style="display:flex">
                  <div style="width:40%">Beneficiary Name:</div>
                  <div style="width:60%">LISCR - The LISCR Trust Company</div>
                </div>
              </div>
              <div style="width:48%;padding:7px">
                <div style="display:flex;margin-bottom:5px">
                  <div style="width:40%">Bank Name:</div>
                  <div style="width:60%;color:#00f">Bank of America N.A. <br>8300 Greensboro Dr. Suite 360 <br>McLean, VA 22102, USA </div>
                </div>
                <div style="display:flex;margin-bottom:5px">
                  <div style="width:40%">ABA Number:</div>
                  <div style="width:60%">026009593</div>
                </div>
                  <div style="display:flex;margin-bottom:5px">
                       <div style="width:40%">Beneficiary Account Number:</div>
                  <div style="width:60%">435059558233</div>
                
                </div>
                <div style="display:flex">
                  <div style="width:40%">Beneficiary Name:</div>
                  <div style="width:60%">LISCR - The LISCR Trust Company</div>
                </div>
              </div>
            </div>
            <div style="text-align:center;font-weight:700;margin:0 0;font-size:13px;line-height:19px">
              <div style="font-size:11px">PLEASE EMAIL A COPY OF YOUR BANK'S CONFIRMATION OF TRANSFER TO:&nbsp; <a href="mailto:corporate@liscr.com" style="color:#00f; font-size:14px;">corporate@liscr.com</a>&nbsp;AND REFERENCE THE INVOICE NUMBER(S) TO BE PAID </div>
            </div>
          </div>
        </div>
   
      <div style="margin-top:0;display:flex">
        <div style="font-weight:700;width:5%;color: #00ADC3;font-size: 16px;">II.</div>
        <div>
          <div style="font-weight:600;color: #00ADC3;font-size: 16px;">CHECK OR BANK DRAFT</div>
          <div style="margin-top:0;font-size:16px;word-spacing: 0;font-size: 16px;  line-height: 19px;">Please send by mail to LISCR, LLC, 22980 Indian Creek Drive, Suite 200, Dulles, Virginia 20166 USA.
Check/Bank Draft must be in U.S. Dollars and drawn from a US bank payable to:</div>
        </div>
      </div>
      <div style="text-align:center;font-weight:700;margin:0 0;font-size:14px">"LISCR - The LISCR Trust Company"</div>
      <div style="margin-top:0;display:flex">
        <div style="font-weight:700;width:4.4%;color: #00ADC3;font-size: 16px;"></div>
        <div>
          <div style="margin-top:0;font-size:16px;word-spacing: 0;font-size: 16px;  line-height: 19px;">If the check is delivered to a LISCR Regional Office, an additional $20 (handling) fee must be added to the total amount of each check delievered.</div>
        </div>
      </div>
      </div>
      
      </div>`

// const refreshAccessToken = async () => {
//   const savedState = localStorage.getItem("azureAdB2C")
//   const b2cData = JSON.parse(savedState)
//   const formData = new FormData()
//   formData.append('client_id', b2cData.clientId)
//   formData.append('refresh_token', localStorage.getItem("refresh_token"))
//   formData.append('grant_type', 'refresh_token')
//   formData.append('code_verifier', b2cData.codeVerifier)
//   formData.append('redirect_uri', b2cData.hostname)
//   return axios.post(`${b2cData.instance}/${b2cData.domain}/oauth2/v2.0/token?p=${b2cData.signUpSignInPolicyId}`, formData).then(res => {
//     localStorage.setItem("token", res.data.id_token)
//     localStorage.setItem("refresh_token", res.data.refresh_token)
//     return res.data.id_token
//   })
// }

const addResponseInterceptor = async (axiosInstance) => {
  axiosInstance.interceptors.response.use((response) => {
    return response
  }, async function (error) {
    const originalRequest = error.config
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      const access_token = error.response.headers['x-auth-token']
      const refresh_token = error.response.headers['x-refresh-token']
      localStorage.setItem("token", access_token)
      localStorage.setItem("refresh_token", refresh_token)
      originalRequest.headers['Authorization'] = `Bearer ${access_token}`
      return axiosInstance(originalRequest)
    }
    return Promise.reject(error)
  })
}

export const DefaultConfig = () => {
  let authAxios
  let authAxiosMulti
  if (localStorage.getItem("userData")) {
    const localStorageToken = localStorage.getItem('token')
    const refreshToken = localStorage.getItem('refresh_token')
    authAxios = axios.create({
      baseURL: baseApiUrl,
      headers: { Authorization: `Bearer ${localStorageToken}`, "x-refresh-token": refreshToken },
      withCredentials: true
    })
    addResponseInterceptor(authAxios)
    authAxiosMulti = axios.create({
      baseURL: baseApiUrl,
      headers: {
        Authorization: `Bearer ${localStorageToken}`,
        "Content-Type": "multipart/form-data",
        "x-refresh-token": refreshToken
      },
      withCredentials: true

    })
    addResponseInterceptor(authAxiosMulti)
  }

  const processAgents = (agents, validationData) => {

    return agents.reduce((acc, item1) => {

      const entry = validationData.find((data) => data.agentNumber === Number(item1.agentId))
      if (entry?.agentRoles.some(role => role.trim() === "Tonnage") && entry.agentCountry === "Greece") {
        acc.push({
          value: item1.agentId.toString(),
          label: `${item1.agentName || item1.name} (${item1.agentId})`,
          agentDepartmentId: item1.agentDepartmentId
        })
      }
      return acc
    }, [])
  }

  const sorter = (sortname, sortorder, filteredData) => {
    const sortData = filteredData
    sortData.sort((a, b) => {
      if (typeof a[sortname] === "number" && typeof b[sortname] === "number") {
        if (sortorder === "asc") {
          return parseInt(a[sortname]) > parseInt(b[sortname]) ? 1 : parseInt(a[sortname]) < parseInt(b[sortname]) ? -1 : 0
        } else {
          return parseInt(b[sortname]) > parseInt(a[sortname]) ? 1 : parseInt(b[sortname]) < parseInt(a[sortname]) ? -1 : 0
        }
      } else if (
        typeof a[sortname] === "string" && typeof b[sortname] === "string") {
        if (sortorder === "asc") {
          return a[sortname].toLowerCase() > b[sortname].toLowerCase() ? 1 : a[sortname].toLowerCase() < b[sortname].toLowerCase() ? -1 : 0
        } else {
          return b[sortname].toLowerCase() > a[sortname].toLowerCase() ? 1 : b[sortname].toLowerCase() < a[sortname].toLowerCase() ? -1 : 0
        }
      } else {
        if (sortorder === "asc") {
          return a[sortname] > b[sortname] ? 1 : a[sortname] < b[sortname] ? -1 : 0
        } else {
          return b[sortname] > a[sortname] ? 1 : b[sortname] < a[sortname] ? -1 : 0
        }
      }
    })
    return sortData
  }

  const ReplaceString = (value) => {
    if (value) {
      return new Date(value.replace(/(\d+)(st|nd|rd|th)/, '$1'))
    }
    return ''
  }

  const mockData = [
    {
      id: 1,
      documentNumber: '12345',
      vesselOrCorpName: 'Vessel A',
      vesselOrCorpNumber: '67890',
      sourceSystem: true,
      invoiceDesc: 'Annual Tonnage Tax Recipient',
      fromDate: '2024-01-01',
      toDate: '2024-01-31',
      paymentStatus: 'Paid'
    },
    {
      id: 2,
      documentNumber: '54321',
      vesselOrCorpName: 'Vessel B',
      vesselOrCorpNumber: '09876',
      sourceSystem: false,
      invoiceDesc: 'Annual Tonnage Tax Recipient',
      fromDate: '2024-02-01',
      toDate: '2024-02-28',
      paymentStatus: 'Pending'
    },
    {
      id: 3,
      documentNumber: '67890',
      vesselOrCorpName: 'Vessel C',
      vesselOrCorpNumber: '12345',
      sourceSystem: true,
      invoiceDesc: 'Annual Tonnage Tax Recipient',
      fromDate: '2024-03-01',
      toDate: '2024-03-31',
      paymentStatus: 'Paid'
    },
    {
      id: 4,
      documentNumber: '98765',
      vesselOrCorpName: 'Vessel D',
      vesselOrCorpNumber: '54321',
      sourceSystem: false,
      invoiceDesc: 'Annual Tonnage Tax Recipient',
      fromDate: '2024-04-01',
      toDate: '2024-04-30',
      paymentStatus: 'Outstanding'
    },
    {
      id: 5,
      documentNumber: '13579',
      vesselOrCorpName: 'Vessel E',
      vesselOrCorpNumber: '24680',
      sourceSystem: true,
      invoiceDesc: 'Annual Tonnage Tax Recipient',
      fromDate: '2024-05-01',
      toDate: '2024-05-31',
      paymentStatus: 'Paid'
    },
    {
      id: 6,
      documentNumber: '24680',
      vesselOrCorpName: 'Vessel F',
      vesselOrCorpNumber: '13579',
      sourceSystem: false,
      invoiceDesc: 'Annual Tonnage Tax Recipient',
      fromDate: '2024-06-01',
      toDate: '2024-06-30',
      paymentStatus: 'Pending'
    },
    {
      id: 7,
      documentNumber: '11223',
      vesselOrCorpName: 'Vessel G',
      vesselOrCorpNumber: '33445',
      sourceSystem: true,
      invoiceDesc: 'Annual Tonnage Tax Recipient',
      fromDate: '2024-07-01',
      toDate: '2024-07-31',
      paymentStatus: 'Paid'
    },
    {
      id: 8,
      documentNumber: '22334',
      vesselOrCorpName: 'Vessel H',
      vesselOrCorpNumber: '44556',
      sourceSystem: false,
      invoiceDesc: 'Annual Tonnage Tax Recipient',
      fromDate: '2024-08-01',
      toDate: '2024-08-31',
      paymentStatus: 'Pending'
    },
    {
      id: 9,
      documentNumber: '33445',
      vesselOrCorpName: 'Vessel I',
      vesselOrCorpNumber: '55667',
      sourceSystem: true,
      invoiceDesc: 'Annual Tonnage Tax Recipient',
      fromDate: '2024-09-01',
      toDate: '2024-09-30',
      paymentStatus: 'Paid'
    },
    {
      id: 10,
      documentNumber: '44556',
      vesselOrCorpName: 'Vessel J',
      vesselOrCorpNumber: '66778',
      sourceSystem: false,
      invoiceDesc: 'Annual Tonnage Tax Recipient',
      fromDate: '2024-10-01',
      toDate: '2024-10-31',
      paymentStatus: 'Outstanding'
    }
    // Add more rows as needed
  ]

  const DateFormat = (value) => {
    if (value) {
      const monthname = monthnames[new Date(value).getMonth()]
      const datevalue = `0${new Date(value).getDate()}`.slice(-2)
      const yearvalue = new Date(value).getFullYear()
      return `${datevalue} ${monthname} ${yearvalue}`
    } else {
      return ""
    }
  }

  const getThreeLetterTimeZone = () => {
    const dateString = new Date().toString()
    const match = dateString.match(/\(([A-Za-z\s].*)\)/)
    if (match && match.length > 1) {
      const abbreviation = match[1].split(' ').map(word => word[0]).join('')
      return abbreviation
    }
    return "Unknown Time Zone"
  }

  const frpRoleColor = (roleName) => {
    let color = ''
    if (roleName === 'ISM') {
      color = 'red'
    } else if (roleName === 'ISPS') {
      color = 'green'
    } else if (roleName === 'Miscellaneous Billing') {
      color = '#b1b100'
    } else if (roleName === 'Tonnage') {
      color = 'blue'
    }
    return color
  }

  const StringtoDateMonthYearFormat = (valueDate) => {
    if (valueDate) {
      const splitString = valueDate.split("-")
      if (splitString.length === 3) {
        const datevalue = splitString[0]
        const findMonth = fullmonthnames.find(find => find.key === splitString[1])
        let monthname = ''
        if (findMonth) {
          monthname = findMonth.value
        }
        const yearvalue = splitString[2]
        return `${datevalue}-${monthname}-${yearvalue}`
      }
    }
    return ""
  }

  const YearMonthDateFormat = (value) => {
    if (value) {
      // const splitDateFormat = value.split("T")
      // const splitDate = splitDateFormat.length > 0 ? splitDateFormat[0] : ''
      // if (splitDate) {
      //   const splitString = splitDate.split("-")
      //   if (splitString.length === 3) {
      //     const yearvalue = splitString[0]
      //     const findMonth = fullmonthnames.find(find => find.key === splitString[1])
      //     let monthname = ''
      //     if (findMonth) {
      //       monthname = findMonth.value
      //     }
      //     const datevalue = splitString[2]
      //     return `${monthname} ${datevalue && datevalue.replace(/^0/, '')}${datesList[datevalue - 1]}, ${yearvalue}`
      //   }
      // }
      const date = new Date(value)

      // Get the day, month, and year components
      let day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      if (day < 10) {
        day = `0${day}`
      }
      // Format the date
      const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

      return formattedDate
    }
    return ""
  }

  function getDistinctAgentIds(data) {
    const distinctAgentIds = [...new Set(data.map(item => (item.agentId ? item.agentId : item.clientNumber)))].join(',')
    return distinctAgentIds
  }

  const formattedDateIssueFixed = (data) => {
    if (data) {
      const date = new Date(data)
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      const day = date.getUTCDate()
      const month = months[date.getUTCMonth()]
      const year = date.getUTCFullYear()
      const formattedDate = `${day} ${month} ${year}`
      return formattedDate
    }
  }


  const formattedDateIssueFixedExporttoExcel = (data) => {
    if (data) {
      const date = new Date(data)
      return date.toISOString().split("T")[0]
    }
    return null
  }


  const DateConversion = (dateStr) => {
    if (dateStr) {
      // Create a Date object from the input string
      const date = new Date(dateStr)

      // Get the day, month, and year components
      let day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      if (day < 10) {
        day = `0${day}`
      }
      // Format the date
      const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

      return formattedDate
    }
    return ''
    // if (dateStr) {
    //   // Convert to Date object
    //   const date = new Date(dateStr)

    //   // Custom function to add ordinal suffix
    //   function addOrdinalSuffix(day) {
    //     if (day >= 11 && day <= 13) {
    //       return `${day}th`
    //     }

    //     const lastDigit = day % 10
    //     switch (lastDigit) {
    //       case 1:
    //         return `${day}st`
    //       case 2:
    //         return `${day}nd`
    //       case 3:
    //         return `${day}rd`
    //       default:
    //         return `${day}th`
    //     }
    //   }

    //   // Format date and time
    //   const formattedDate = date.toLocaleDateString("en-US", {
    //     month: "short",
    //     day: "numeric",
    //     year: "numeric"
    //   })

    //   // Extract day from the formatted date
    //   const day = formattedDate.match(/\d+/)[0]

    //   // Add ordinal suffix to the day
    //   const ordinalDay = addOrdinalSuffix(day)

    //   // Combine the formatted date, ordinal day, and formatted time
    //   const formattedDateTime = `${formattedDate.replace(/\d+/, ordinalDay)}`
    //   return formattedDateTime
    // }
    // return ''
  }

  const DateTimeConversion = (dateStr) => {
    if (dateStr) {
      // // Convert to Date object
      // const date = new Date(dateStr)

      // // Custom function to add ordinal suffix
      // function addOrdinalSuffix(day) {
      //   if (day >= 11 && day <= 13) {
      //     return `${day}th`
      //   }

      //   const lastDigit = day % 10
      //   switch (lastDigit) {
      //     case 1:
      //       return `${day}st`
      //     case 2:
      //       return `${day}nd`
      //     case 3:
      //       return `${day}rd`
      //     default:
      //       return `${day}th`
      //   }
      // }

      // // Format date and time
      // const formattedDate = date.toLocaleDateString("en-US", {
      //   month: "short",
      //   day: "numeric",
      //   year: "numeric"
      // })
      // const formattedTime = date.toLocaleTimeString("en-US", {
      //   hour: '2-digit', minute: '2-digit', second: '2-digit'
      // })

      // // Extract day from the formatted date
      // const day = formattedDate.match(/\d+/)[0]

      // // Add ordinal suffix to the day
      // const ordinalDay = addOrdinalSuffix(day)

      // // Combine the formatted date, ordinal day, and formatted time
      // const formattedDateTime = `${formattedDate.replace(/\d+/, ordinalDay)} ${formattedTime}`
      // return formattedDateTime

      // Create a Date object from the input string
      const date = new Date(dateStr)
      // Get the day, month, and year components
      let day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      if (day < 10) {
        day = `0${day}`
      }
      // Format the date
      const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

      const formattedTime = date.toLocaleTimeString("en-US", {
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      })
      const formattedDateTime = `${formattedDate} ${formattedTime}`

      return formattedDateTime
    }
    return ''
  }

  const AmountFormat = (amount) => {
    if (isNaN(amount)) {
      return ''
    }
    let x = Number.parseFloat(amount).toFixed(2)
    const sign = x.startsWith('-') ? '-' : ''
    x = x.replace('-', '')
    const parts = x.split('.')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return sign + parts.join('.')
  }

  const selectStyles = {
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999
    }),
    container: (provided) => ({
      ...provided,
      marginTop: 0
    }),
    valueContainer: (provided) => ({
      ...provided,
      overflow: "visible"
    }),
    placeholder: (base, state) => ({
      ...base,
      position: "absolute",
      top: (state.hasValue || state.selectProps.inputValue || state.selectProps.menuIsOpen) ? '-45%' : '20%',
      transition: 'top 0.2s, font-size 0.2s',
      fontSize: (state.hasValue || state.selectProps.inputValue || state.selectProps.menuIsOpen) && 14,
      padding: "0 5px",
      // fontWeight: 500,
      color: '#000'
    }),
    option: (provided, state) => {
      const { data, isFocused, isSelected, isDisabled } = state

      if (data.isSanctioned) {
        return {
          ...provided,
          color: "#ff0000 !important", // red text
          cursor: isDisabled ? "not-allowed" : "pointer",
          fontWeight: isSelected ? 500 : 500
        }
      }

      return {
        ...provided,
        backgroundColor:
          isFocused || isSelected ? "#f0f0f0" : "white",
        color: "black",
        cursor: isDisabled ? "not-allowed" : "pointer",
        "&:active": {
          backgroundColor: "#ddd"
        }
      }
    }
  }
  const formatYearDate = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const slashFormattedDate = (date) => {

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${month}/${day}/${year}`
  }
  const emailDurationTime = 30 * 1000
  const zoomInOut = { animate: { opacity: 1, scale: 1 }, transition: { duration: 1, delay: 0.1 }, initial: { opacity: 0, scale: 0.5 }, exit: { opacity: 0, scale: 0.5 } }
  const leftToRight = { animate: { x: 0 }, transition: { type: 'slide', stiffness: 120 }, initial: { x: '-100%' }, exit: { x: '100%' } }
  const CreditCardpercentage = 0.04
  const CreditCardNote = 'Please note that a 4% Convenience Fee is charged based on the transaction total'
  return {
    headerText,
    selectStyles,
    DocusignTitle,
    InvoicePaymentModes,
    InvoicePaymentStatus,
    specialCharacterErrorMessage,
    specialCharacterPattern,
    WOStatus,
    errorresponse,
    authAxios,
    authAxiosMulti,
    PaymentInstructions,
    PaymentInstructionsforCO,
    sorter,
    datesList,
    monthnames,
    DateFormat,
    slashFormattedDate,
    formattedDateIssueFixed,
    formattedDateIssueFixedExporttoExcel,
    getThreeLetterTimeZone,
    YearMonthDateFormat,
    AmountFormat,
    StringtoDateMonthYearFormat,
    DateTimeConversion,
    DateConversion,
    ReplaceString,
    mockData,
    emailDurationTime,
    zoomInOut,
    leftToRight,
    formatYearDate,
    CreditCardpercentage,
    CreditCardNote,
    frpRoleColor,
    processAgents,
    getDistinctAgentIds
  }
}
